import {
  forEach as _forEach,
  forIn as _forIn,
} from 'lodash';

const map = {
  "video/h261": [`h261`],
  "video/h263": [`h263`],
  "video/h264": [`h264`],
  "video/jpeg": [`jpgv`],
  "video/jpm": [ `jpm`, `jpgm` ],
  "video/mj2": [ `mj2`, `mjp2` ],
  "video/mp4": [ `mp4`, `mp4v`, `mpg4` ],
  "video/mpeg": [ `mpeg`, `mpg`, `mpe`, `m1v`, `m2v` ],
  "video/ogg": [`ogv`],
  "video/quicktime": [ `qt`, `mov` ],
  "video/vnd.mpegurl": [ `mxu`, `m4u` ],
  "video/webm": [`webm`],
  "video/x-m4v": [`m4v`],
};

export default (filename, fallback) => {
  const ext = filename.replace(/.*[./\\]/, ``).toLowerCase();
  const defaultType = `application/octet-stream`;
  const types = Object.create(null);
  _forIn(map, (extensions, key) => {
    _forEach(extensions, (extension) => {
      types[extension] = key;
    });
  });

  return types[ext] || fallback || defaultType;
};
